import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { SwiperConfigInterface, SwiperFadeEffectInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';
// import AOS from 'aos';
@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomePageComponent implements OnInit {
  public HudsunSlides = [];
  public whyChooseSlides = ['https://hudsonmilk.com/skin1_layouts/modern/images/hudson/why-us-2.png', 'https://hudsonmilk.com/skin1_layouts/modern/images/hudson/why-us-3.png', 'https://hudsonmilk.com/skin1_layouts/modern/images/hudson/why-us-4.png']
  public Swconfig: SwiperConfigInterface = {
    pagination: true
  };
  private SwiperFadeEffectInterface: SwiperFadeEffectInterface = {
    crossFade: true
  }


  public HomeSliderConfig: SwiperConfigInterface = {};
  private SwiperFadeEffectInterfaceLg: SwiperFadeEffectInterface = {
    crossFade: true
  }
  dynamicContent: string = 'MILK';
  contents: string[] = ['MILK','Eggs', 'Butter', 'Yocurt', 'CHEESE', 'Produce', 'Beef', 'Poultry', 'PORK'];
  currentIndex: number = 0;
  
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.changeContent = this.changeContent.bind(this);
   }

  ngOnInit(): void {
    if(isPlatformBrowser(this.platformId)) {
      this.HomeSliderConfig = {
        slidesPerView: 1,
        spaceBetween: 0,        
        loop: true,
        speed: 800,
        effect: "fade"
        
      };
  
      let slider1 = 'assets/images/slider-1.jpg', slider2 = 'assets/images/slider-2.jpg';
      this.HudsunSlides = [
        { title: 'Get the best', subtitle: 'Delivered To Your Door', image: slider1 },
        { title: 'Get the best', subtitle: 'Delivered To Your Door', image: slider2 }
      ];
      this.changeContent();
      // document.getElementById('rootEl').classList.add("isHome");
    }
  }
  changeContent(): void {
       this.currentIndex = (this.currentIndex + 1) % this.contents.length;
      this.dynamicContent = this.contents[this.currentIndex];
  }
  // ngAfterViewInit(){
  //   this.changeContent();
  // }
  // ngAfterContentInit() {
  //   this.changeContent();
  // }
}
